'use client';

import * as Sentry from '@sentry/nextjs';
import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next-nprogress-bar';
import { useEffect } from 'react';

import { GeneralError } from '@/components/error/general-error';

import { Button } from '../ui/button';

export interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

export const ErrorPage = ({ error }: ErrorPageProps) => {
  const router = useRouter();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="container flex min-h-screen w-full flex-col items-center justify-center">
      <GeneralError />
      <p className="mb-4 text-center text-gray-600">{error.message}</p>
      <Button onClick={() => router.back()} className="group flex w-auto items-center gap-1.5 px-4">
        <ArrowLeft className="transition-transform group-hover:-translate-x-1" />
        Zpět
      </Button>
    </div>
  );
};
